export enum ERedirectActionTypeDB {
  SHOW_EVENT = 'showEventEvent',
  SUBMIT_SHIPPING_DETAILS = 'submitShippingDetails',
  OPEN_MEETING_LINK = 'openMeetingLink',
  SHOW_HOST_EVENT = 'showHostEvents',
}

export enum ERedirectActionTypeUI {
  SHOW_EVENT = 'showEventEvent',
  SUBMIT_SHIPPING_DETAILS = 'submitShippingDetails',
  OPEN_MEETING_LINK = 'openMeetingLink',
  SHOW_HOST_EVENT = 'showHostEvents',
}
